/**
 * ExpandableSectionsContainer Component
 * Generic container for multiple expandable sections using usePersistedState + ExpandableLabel.
 * Eliminates duplication across D24/D30/D40 DivisionsTable components.
 */

import React from 'react';
import { usePersistedState } from '../../../../../hooks/usePersistedState';
import { ExpandableLabel } from '../ExpandableLabel';

export interface ExpandableSection {
  storageKey: string;
  label: string;
  component: React.ReactNode;
}

interface ExpandableSectionRowProps {
  section: ExpandableSection;
}

/**
 * Single expandable section row with persisted expand/collapse state
 */
const ExpandableSectionRow: React.FC<ExpandableSectionRowProps> = ({ section }) => {
  const [isExpanded, setIsExpanded] = usePersistedState(section.storageKey, false);

  return (
    <>
      <div className="planet-detail-row">
        <ExpandableLabel
          label={section.label}
          isExpanded={isExpanded}
          onToggle={() => setIsExpanded(!isExpanded)}
        />
      </div>
      {isExpanded && section.component}
    </>
  );
};

interface ExpandableSectionsContainerProps {
  sections: ExpandableSection[];
}

export const ExpandableSectionsContainer: React.FC<ExpandableSectionsContainerProps> = ({ sections }) => {
  return (
    <>
      {sections.map((section) => (
        <ExpandableSectionRow key={section.storageKey} section={section} />
      ))}
    </>
  );
};
